import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  carrierDoesNotProvideRate: {
    description: 'Information on tooltip that the carrier does not provide the rate.',
    defaultMessage: 'A selected carrier does not send rates. Check with your carrier for rate details.',
    id: 'aszR56',
  },
});
